import { Button, Grid } from "@material-ui/core";
import { useFormikContext } from "formik";
import { useDispatch } from "react-redux";
import { Client, yesNoOptions } from "../../common/types";
import { getDefaultDisclosureStatementPdfAsync } from "../../store/adviser";
import { FormLabel } from "../controls/helpers";
import { Select } from "../controls/inputs";

const EditPreviewDisclosure = ({ onEditClick }: { onEditClick: () => void }) => {
  const dispatch = useDispatch();
  const { values } = useFormikContext<Client>();

  return (
    <>
      <Grid item xs={12}>
        <Grid container spacing={1}>
          <Grid item md={7} sm={6} xs={12} style={{ paddingTop: 15 }}>
            <FormLabel label="Use system generated disclosure?" tooltip="This template will be sent to your client with their link. Preview your disclosure and check all information is accurate." />
          </Grid>
          <Grid item md={5} sm={6} xs={12}>
            <Select name="useNZFundsDisclosureTemplate" options={yesNoOptions} />
          </Grid>
        </Grid>
      </Grid>
      {!!values.useNZFundsDisclosureTemplate && (
        <Grid item xs={12}>
          <Grid container spacing={1}>
            <Grid item md={7} sm={6} xs={12} />
            <Grid item md={5} sm={6} xs={12}>
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <Button variant="contained" fullWidth onClick={() => dispatch(getDefaultDisclosureStatementPdfAsync())}>
                    Preview
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button variant="contained" color="primary" fullWidth onClick={onEditClick}>
                    Edit
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default EditPreviewDisclosure;
